/*
 * HYDN · Recompensas
 * - Barra de progreso: llavero gratis (desde $40.000) y envío gratis (desde $69.990).
 * - Agrega/retira automáticamente 1 llavero de regalo y permite elegir el diseño.
 * El precio $0 del llavero lo aplica SIEMPRE el descuento de Shopify; este script solo
 * pone el producto en el carrito y muestra el progreso.
 */
(() => {
  if (window.HydnRewards) return;

  const GIFT_PROP = '_hydn_regalo';
  const DISMISS_KEY = 'hydn-gift-dismissed';
  const SUGGEST_WINDOW = 35000 * 100; // sugerir solo si faltan $35.000 o menos
  const SUGGEST_MAP = {
    'musculosa-hydn-hybrid-athlete': ['short-hydn-lifestyle', 'oversize-hydn-hybrid-athlete'],
    'oversize-hydn-hybrid-athlete': ['musculosa-hydn-hybrid-athlete', 'short-hydn-lifestyle'],
    'short-hydn-lifestyle': ['oversize-hydn-hybrid-athlete', 'musculosa-hydn-hybrid-athlete'],
    'musculosa-hydn-1': ['short-hydn-lifestyle', 'short-hydn-1'],
    'dry-fit-hydn-1': ['short-hydn-1', 'short-hydn-lifestyle'],
    'short-hydn-1': ['dry-fit-hydn-1', 'musculosa-hydn-hybrid-athlete'],
    'poleron-hydn-hybrid-club-1': ['short-hydn-lifestyle', 'oversize-hydn-hybrid-athlete'],
  };
  const SUGGEST_DEFAULT = [
    'short-hydn-lifestyle',
    'musculosa-hydn-hybrid-athlete',
    'oversize-hydn-hybrid-athlete',
    'dry-fit-hydn-1',
    'short-hydn-1',
  ];

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const fmt = (cents) => '$' + Math.max(0, Math.round(cents / 100)).toLocaleString('es-CL');
  const store = {
    get(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} },
    del(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} },
  };

  // Valores por defecto (en centavos, igual que /cart.js); el snippet hydn-rewards puede sobrescribirlos.
  const CONF = { giftThreshold: 4000000, shipThreshold: 6999000, giftHandle: 'llavero-hydn', giftProductId: null };
  const tplEl = document.getElementById('HydnRewardsTemplate');
  const first = document.querySelector('[data-hydn-rewards]') || (tplEl && tplEl.content.firstElementChild);
  if (first) {
    CONF.giftThreshold = parseInt(first.dataset.giftThreshold, 10) || CONF.giftThreshold;
    CONF.shipThreshold = parseInt(first.dataset.shipThreshold, 10) || CONF.shipThreshold;
    CONF.giftHandle = first.dataset.giftHandle || CONF.giftHandle;
    CONF.giftProductId = parseInt(first.dataset.giftProductId, 10) || null;
  }

  let cart = null;
  let giftProduct = null;
  let busy = false;
  let hadOwnGift = false;
  const productCache = {};

  const getJSON = (url) =>
    fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  const postJSON = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then((r) => r.json().then((j) => (r.ok ? j : Promise.reject(j))));

  const isGiftProduct = (line) =>
    (CONF.giftProductId && line.product_id === CONF.giftProductId) || line.handle === CONF.giftHandle;
  const isOwnGift = (line) => isGiftProduct(line) && line.properties && line.properties[GIFT_PROP];

  function compute(c) {
    // eligible: prendas (sin ningún llavero) -> umbral del llavero gratis.
    // shipBase: total del carrito sin la línea de regalo (en el pago vale $0) -> umbral de envío gratis.
    let eligible = 0;
    let giftValue = 0;
    c.items.forEach((l) => {
      if (!isGiftProduct(l)) eligible += l.final_line_price;
      else if (isOwnGift(l)) giftValue += l.final_line_price;
    });
    const shipBase = Math.max(0, c.total_price - giftValue);
    return {
      eligible,
      shipBase,
      giftOk: eligible >= CONF.giftThreshold,
      shipOk: shipBase >= CONF.shipThreshold,
      giftLines: c.items.filter(isGiftProduct),
      ownGift: c.items.find(isOwnGift) || null,
    };
  }

  /* ---------- Contenedores en carrito ---------- */
  function makeBar(context) {
    const tpl = document.getElementById('HydnRewardsTemplate');
    if (!tpl || !tpl.content.firstElementChild) return null;
    const el = tpl.content.firstElementChild.cloneNode(true);
    el.dataset.context = context;
    el.classList.remove('hydn-rewards--drawer');
    el.classList.add('hydn-rewards--' + context);
    return el;
  }

  function ensureContainers() {
    const hasItems = cart && cart.item_count > 0;
    const drawerHeader = document.querySelector('#CartDrawer .drawer__header');
    const drawerBar = document.querySelector('#CartDrawer [data-hydn-rewards]');
    if (drawerHeader && hasItems && !drawerBar) {
      const el = makeBar('drawer');
      if (el) drawerHeader.insertAdjacentElement('afterend', el);
    } else if (drawerBar && !hasItems) {
      drawerBar.remove();
    }
    const cartWarnings = document.querySelector('cart-items .cart__warnings');
    const cartBar = document.querySelector('cart-items [data-hydn-rewards]');
    if (cartWarnings && hasItems && !cartBar) {
      const el = makeBar('cart');
      if (el) cartWarnings.insertAdjacentElement('beforebegin', el);
    } else if (cartBar && !hasItems) {
      cartBar.remove();
    }
  }

  function markGiftRows() {
    if (!cart) return;
    document.querySelectorAll('.hydn-gift-line').forEach((r) => r.classList.remove('hydn-gift-line'));
    cart.items.forEach((l, i) => {
      if (!isOwnGift(l)) return;
      ['CartDrawer-Item-', 'CartItem-'].forEach((p) => {
        const row = document.getElementById(p + (i + 1));
        if (row) row.classList.add('hydn-gift-line');
      });
    });
  }

  /* ---------- Render ---------- */
  function renderAll() {
    if (!cart) return;
    ensureContainers();
    markGiftRows();
    document.querySelectorAll('[data-hydn-rewards]').forEach(renderOne);
  }

  function renderOne(el) {
    const s = compute(cart);
    const msg = el.querySelector('.hydn-rewards__message');
    let text;
    let sub = '';
    if (s.giftOk && s.shipOk) {
      text = '¡Desbloqueaste tus beneficios HYDN!';
    } else if (s.giftOk) {
      text = '¡Tu llavero HYDN está desbloqueado!';
      sub = 'Te faltan ' + fmt(CONF.shipThreshold - s.shipBase) + ' para envío gratis';
    } else {
      text = 'Te faltan ' + fmt(CONF.giftThreshold - s.eligible) + ' para tu llavero HYDN gratis';
      sub = s.shipOk ? 'Envío gratis desbloqueado' : 'Envío gratis desde ' + fmt(CONF.shipThreshold);
    }
    msg.innerHTML = '';
    msg.appendChild(document.createTextNode(text));
    if (sub) {
      const small = document.createElement('span');
      small.className = 'hydn-rewards__sub';
      small.textContent = sub;
      msg.appendChild(small);
    }

    // HYDN: relleno rojo por tramos, alineado con la posición real de cada ícono.
    // Tramo 1: $0 -> llavero. Tramo 2: llavero -> envío gratis.
    const fill = el.querySelector('.hydn-rewards__fill');
    if (fill) fill.style.setProperty('--hydn-progress', progressPct(el, s).toFixed(2) + '%');
    el.querySelectorAll('[data-milestone="gift"], [data-goal="gift"]').forEach((n) => n.classList.toggle('is-done', s.giftOk));
    el.querySelectorAll('[data-milestone="ship"], [data-goal="ship"]').forEach((n) => n.classList.toggle('is-done', s.shipOk));
    el.classList.toggle('is-complete', s.giftOk && s.shipOk);

    renderGiftPicker(el, s);
    renderSuggestion(el, s);
  }

  function progressPct(el, s) {
    const clamp = (n) => Math.max(0, Math.min(1, n));
    const mark = el.querySelector('[data-milestone="gift"]');
    let giftPos = mark ? parseFloat(mark.style.getPropertyValue('--hydn-pos')) : NaN;
    if (!(giftPos > 0 && giftPos < 100)) giftPos = (CONF.giftThreshold / CONF.shipThreshold) * 100;
    if (s.shipOk && s.giftOk) return 100;
    const t1 = clamp(s.eligible / CONF.giftThreshold);
    const t2 = s.giftOk ? clamp((s.shipBase - CONF.giftThreshold) / (CONF.shipThreshold - CONF.giftThreshold)) : 0;
    return t1 * giftPos + t2 * (100 - giftPos);
  }

  function renderGiftPicker(el, s) {
    const box = el.querySelector('[data-hydn-gift]');
    if (!box) return;
    const ctx = el.dataset.context;
    if (!s.giftOk || ctx === 'product') {
      box.hidden = true;
      box.innerHTML = '';
      return;
    }
    if (!giftProduct) {
      loadGiftProduct().then(() => renderAll());
      return;
    }
    const available = giftProduct.variants.filter((v) => v.available);
    box.innerHTML = '';
    if (!available.length) {
      box.hidden = false;
      box.textContent = 'Los llaveros de regalo están agotados por ahora.';
      return;
    }
    const current = s.ownGift ? s.ownGift.variant_id : null;
    const paidGift = !s.ownGift && s.giftLines.length > 0;
    const title = document.createElement('p');
    title.className = 'hydn-rewards__gift-title';
    if (paidGift) {
      title.textContent = 'Uno de tus llaveros va de regalo en el pago.';
      box.appendChild(title);
      box.hidden = false;
      return;
    }
    title.textContent = s.ownGift ? 'Elige el diseño de tu llavero gratis:' : 'Tu llavero gratis no está en el carrito.';
    box.appendChild(title);
    const group = document.createElement('div');
    group.className = 'hydn-rewards__designs';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', 'Diseño del llavero gratis');
    if (s.ownGift) {
      giftProduct.variants.forEach((v) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'hydn-rewards__design';
        b.textContent = v.title;
        b.disabled = !v.available || busy;
        b.setAttribute('aria-pressed', String(v.id === current));
        if (!v.available) b.title = 'Agotado';
        b.addEventListener('click', () => {
          if (v.id !== current) swapGift(s.ownGift, v.id);
        });
        group.appendChild(b);
      });
    } else {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'hydn-rewards__design hydn-rewards__design--add';
      b.textContent = 'Agregar mi llavero gratis';
      b.disabled = busy;
      b.addEventListener('click', () => {
        store.del(DISMISS_KEY);
        addGift(available[0].id);
      });
      group.appendChild(b);
    }
    box.appendChild(group);
    box.hidden = false;
  }

  function renderSuggestion(el, s) {
    const box = el.querySelector('[data-hydn-suggest]');
    if (!box) return;
    let remaining = 0;
    if (!s.giftOk) remaining = CONF.giftThreshold - s.eligible;
    else if (!s.shipOk) remaining = CONF.shipThreshold - s.shipBase;
    if (!cart.item_count || remaining <= 0 || remaining > SUGGEST_WINDOW) {
      box.hidden = true;
      box.innerHTML = '';
      return;
    }
    const inCart = new Set(cart.items.map((l) => l.handle));
    const ctxProduct = el.dataset.currentProduct;
    let candidates = [];
    cart.items.forEach((l) => {
      (SUGGEST_MAP[l.handle] || []).forEach((h) => candidates.push(h));
    });
    candidates = candidates.concat(SUGGEST_DEFAULT).filter((h, i, a) => a.indexOf(h) === i && !inCart.has(h) && h !== ctxProduct);
    pickSuggestion(candidates).then((p) => {
      if (!p) {
        box.hidden = true;
        box.innerHTML = '';
        return;
      }
      const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      box.innerHTML =
        '<p class="hydn-rewards__suggest-title">Completa tu uniforme</p>' +
        '<a class="hydn-rewards__suggest-item" href="' + p.url + '">' +
        (img ? '<img src="' + img + '" alt="" width="48" height="64" loading="lazy">' : '') +
        '<span class="hydn-rewards__suggest-name"></span>' +
        '<span class="hydn-rewards__suggest-price">' + fmt(p.price) + '</span>' +
        '<span class="hydn-rewards__suggest-cta">Ver</span></a>';
      box.querySelector('.hydn-rewards__suggest-name').textContent = p.title;
      box.hidden = false;
    });
  }

  function pickSuggestion(handles) {
    const tryNext = (i) => {
      if (i >= handles.length || i > 4) return Promise.resolve(null);
      return loadProduct(handles[i]).then((p) => (p && p.available ? p : tryNext(i + 1)));
    };
    return tryNext(0);
  }

  function loadProduct(handle) {
    if (!(handle in productCache)) {
      productCache[handle] = getJSON(root + 'products/' + handle + '.js').catch(() => null);
    }
    return productCache[handle];
  }

  function loadGiftProduct() {
    return loadProduct(CONF.giftHandle).then((p) => {
      giftProduct = p;
      if (p && !CONF.giftProductId) CONF.giftProductId = p.id;
      return p;
    });
  }

  /* ---------- Cart sync ---------- */
  function sectionsToRender() {
    const list = [];
    if (document.getElementById('CartDrawer')) list.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) list.push('cart-icon-bubble');
    const main = document.getElementById('main-cart-items');
    if (main && main.dataset.id) list.push(main.dataset.id);
    const footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) list.push(footer.dataset.id);
    return list;
  }

  function applySections(sections) {
    if (!sections) return;
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
    Object.keys(sections).forEach((key) => {
      const html = sections[key];
      if (!html) return;
      const doc = parse(html);
      if (key === 'cart-drawer') {
        const fresh = doc.querySelector('#CartDrawer');
        const target = document.getElementById('CartDrawer');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.toggle('is-empty', cart && cart.item_count === 0);
      } else if (key === 'cart-icon-bubble') {
        const fresh = doc.querySelector('.shopify-section');
        const target = document.getElementById('cart-icon-bubble');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      } else {
        const fresh = doc.querySelector('.js-contents');
        const target = document.querySelector('#shopify-section-' + key + ' .js-contents');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      }
    });
  }

  function mutate(promiseFactory) {
    busy = true;
    renderAll();
    return promiseFactory()
      .then((res) => {
        if (res && res.sections) applySections(res.sections);
      })
      .catch(() => {})
      .then(() => getJSON(root + 'cart.js'))
      .then((c) => {
        cart = c;
        busy = false;
        hadOwnGift = !!compute(c).ownGift;
        renderAll();
      })
      .catch(() => {
        busy = false;
        renderAll();
      });
  }

  function addGift(variantId) {
    const props = {};
    props[GIFT_PROP] = '1';
    return mutate(() =>
      postJSON(root + 'cart/add.js', {
        items: [{ id: variantId, quantity: 1, properties: props }],
        sections: sectionsToRender(),
      })
    );
  }

  function removeLine(line) {
    return mutate(() =>
      postJSON(root + 'cart/change.js', { id: line.key, quantity: 0, sections: sectionsToRender() })
    );
  }

  function setQty(line, qty) {
    return mutate(() =>
      postJSON(root + 'cart/change.js', { id: line.key, quantity: qty, sections: sectionsToRender() })
    );
  }

  function swapGift(line, variantId) {
    const props = {};
    props[GIFT_PROP] = '1';
    return mutate(() =>
      postJSON(root + 'cart/change.js', { id: line.key, quantity: 0 }).then(() =>
        postJSON(root + 'cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: props }],
          sections: sectionsToRender(),
        })
      )
    );
  }

  function reconcile() {
    if (!cart || busy) return Promise.resolve();
    const s = compute(cart);

    // El cliente quitó el regalo a mano: no volver a agregarlo en esta sesión.
    if (hadOwnGift && !s.ownGift && s.giftOk) store.set(DISMISS_KEY, '1');
    hadOwnGift = !!s.ownGift;

    if (s.ownGift && !s.giftOk) {
      hadOwnGift = false;
      return removeLine(s.ownGift);
    }
    if (s.ownGift && s.ownGift.quantity > 1) return setQty(s.ownGift, 1);
    if (s.giftOk && !s.ownGift && s.giftLines.length === 0 && !store.get(DISMISS_KEY)) {
      return loadGiftProduct().then((p) => {
        const v = p && p.variants.find((x) => x.available);
        if (v) return addGift(v.id);
      });
    }
    if (!s.giftOk) store.del(DISMISS_KEY);
    return Promise.resolve();
  }

  function refresh() {
    return getJSON(root + 'cart.js')
      .then((c) => {
        cart = c;
        renderAll();
        return reconcile();
      })
      .catch(() => {});
  }

  // Cuando el tema vuelve a dibujar el carrito, reinsertar/repintar la barra y las marcas de regalo.
  let pending = false;
  const observer = new MutationObserver((records) => {
    if (!cart || pending) return;
    const relevant = records.some((r) => {
      const t = r.target;
      if (!t || !t.closest) return false;
      if (t.closest('[data-hydn-rewards]')) return false;
      return !!t.closest('#CartDrawer, cart-items, cart-drawer-items');
    });
    if (!relevant) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      renderAll();
    });
  });
  const startObserver = () => observer.observe(document.body, { childList: true, subtree: true });
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver, { once: true });

  const listen = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // Deja que el tema termine de pintar antes de recalcular.
        setTimeout(refresh, 50);
      });
      return true;
    }
    return false;
  };
  if (!listen()) document.addEventListener('DOMContentLoaded', listen, { once: true });

  window.HydnRewards = { refresh, compute: () => (cart ? compute(cart) : null) };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
